import './Popup.scss';

export default function NewPasswordPopup({ onClick, }) {
    return (
        <div className='popup_container' >
            <div className='white_block' >
                <h3>The new password has been sent to your email</h3>

                <button
                    onClick={onClick}
                >
                    Ok
                </button>


            </div>
        </div>
    )
}